export const getGoogleMapsUrl = ([longitude, latitude]: number[]) =>
  `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
